import { Component, EventEmitter, Input, Output, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
    selector: 'rr-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true,
        }
    ]
})
export class SelectComponent implements ControlValueAccessor {
    @Input() options: Array<any> = [];
    @Input() label: string = '';
    @Input() control: FormControl = new FormControl();
    @Input() placeholder: string = '';
    @Input() optionName: string = '';
    @Input() optionValue: string = '';
    @Input() iconType: string = 'icon';

    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() preselectedValue: any = null;

    @Output() change: EventEmitter<any> = new EventEmitter<any>();

    selectedName: string = '';
    selectedIcon: string = '';
    showOptions: boolean = false;
    elementWidth: string = 'auto';
    elementHeight: string = 'auto';
    errorClass: string = '';

    constructor() { }

    ngOnInit() {

        this.initializeSelectedOption();
        this.control?.valueChanges?.subscribe(() => {
            this.checkValidation();
            this.change.emit(this.control.value);
        });
        if (this.preselectedValue && this.control.value === null) {
            setTimeout(() => {
                this.updateSelectedOption(this.preselectedValue);
            }, 50);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.required) {
            this.control.setValidators(Validators.required);
        }
        if (changes['options']) {
            this.initializeSelectedOption();
        }
        if (changes['preselectedValue']) {
            this.updateSelectedOption(this.preselectedValue);
        }
    }

    initializeSelectedOption() {
        const selectedOption = this.options?.find(option => option[this.optionValue] === this.control.value);
        if (selectedOption) {
            this.selectedName = selectedOption[this.optionName];
            this.selectedIcon = selectedOption.icon || '';
        }
    }

    updateSelectedOption(value: any) {
        const selectedOption = this.options.find(option => option[this.optionValue] === value);
        if (selectedOption) {
            this.selectedName = selectedOption[this.optionName];
            this.selectedIcon = selectedOption.icon || '';
            this.control.setValue(selectedOption[this.optionValue]);
            //   console.log('SELECTED OPTION', this.control.value);
        }

    }

    selectOption(option: any) {
        if (option === undefined) {
            this.selectedName = '';
            this.selectedIcon = '';
            this.control.setValue(null);
            this.showOptions = false;
            this.change.emit(this.control.value);
            return;
        }
        this.change.emit(this.control.value);
        this.selectedName = option[this.optionName];
        this.selectedIcon = option.icon || '';
        this.closeOptions();
        this.control?.setValue(option[this.optionValue]);
        this.onTouched();
    }
    getSelectedOption() {
        return this.options.find(option => option[this.optionValue] === this.control.value);
    }
    toggleOptions(eventTarget: any) {
        if (this.disabled == true) {
            return;
        }

        if (this.showOptions) {
            this.closeOptions();
            return;
        }

        this.showOptions = !this.showOptions;

        if (this.showOptions) {
            setTimeout(() => {
                const element = (eventTarget as HTMLElement).closest('.mainselect');
                if (element) {
                    const width = element.clientWidth;
                    let height = element.clientHeight;
                    if (this.label !== '') height = height + 28;
                    this.elementWidth = width + 2 + 'px';
                    this.elementHeight = height + 10 + 'px';
                } else {
                    this.elementWidth = 'auto';
                    this.elementHeight = 'auto';
                }
            }, 0);
        }
    }

    closeOptions() {
        this.showOptions = false;
    }

    onBackdropClick() {
        this.checkValidation();
        this.closeOptions();
    }

    checkValidation() {
        if (this.required) {
            if (!this.control.value) {
                this.errorClass = 'error';
                if (!this.control.hasError('required')) {
                    this.control.setErrors({ required: true });
                }
            } else {
                this.errorClass = '';
                if (this.control.hasError('required')) {
                    this.control.setErrors(null);
                }
            }
        }
    }

    writeValue(value: any): void {
        if (value !== this.control.value) {
            this.control.setValue(value, { emitEvent: false });
        }
    }

    onChange: any = () => { };
    onTouched: any = () => { };

    registerOnChange(fn: any): void {
        this.control.valueChanges.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
